// Saga create
import createSagaMiddleware from "redux-saga";

// Lib
import { isDev } from "lib/helpers";

// Toolkit
import { configureStore } from "@reduxjs/toolkit";

// Start Saga
import startSaga from "../saga";

// Reducers
import rootReducer from '../reducers';

const saga = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducer,
  middleware: [saga],
  devTools: isDev
});

saga.run(startSaga, store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
